import { Pipe, PipeTransform } from '@angular/core';
/**
 * Pipe that formats the Date values. It is mainly used in the `Date` & `FromToDate` components supported by `UI Studio` tool.
 *
 * This class should not be modified.
 */
@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  /**
   * Formats the Date's value
   * @param value
   * @param temporaltype
   */
  transform(
    value: string,
    temporaltype: string // tslint:disable-next-line:one-line
  ) {
    if (typeof value === 'string') {
      if (value && temporaltype && temporaltype === 'TIMESTAMP') {
        value = value.split(' ')[0];
      }
      if (value && value.includes('yyyy')) {
        return value.toLowerCase().replace('yyyy', 'yy');
      }
    }
    return value;
  }
}
